<template>
  <v-container fluid>
    <v-layout align-start>
      <v-flex>
          <v-expand-transition>
          <v-card flat v-show="step == 1">          
            <v-row class="mt-n7" no-gutters justify="center">
              <span style="font-size: 34px; color: #616161"
                ><v-icon large class="pr-1 pb-2">autorenew</v-icon>Ajuste de inventario</span
              >
            </v-row>
            <HeaderFilters
              v-if="showHeader"
              @refreshWarehouse="getAdjustments"
              :filter_default="defaultFilters"
              :show_all_option="true"
              :show_date_start="true"
            />
          <v-card flat class="mt-4">
            <v-card-text>
              <v-card outlined class="mt-2 pt-2">
                <v-card-text class="pa-0">
                  <v-data-table
                    :headers="headerArticle"
                    :search="search"
                    :items="adjustments_filtered"
                    item-key="id"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: [10, 20, 30, 40, 50] }"
                    :loading="loading_adjustments"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Ajustes</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <span>{{ adjustments.length }}</span>
                        <v-spacer></v-spacer>
                        <v-text-field
                          class="text-xs-center"
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-spacer></v-spacer>
                        <v-menu bottom origin="center center" transition="scale-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="mr-2 mt-n2"
                              color="success"
                              dark
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-download</v-icon>
                            </v-btn>
                          </template>
  
                          <v-list>
                            <v-list-item
                              @click="resume_report()"
                              :disabled="adjustments_filtered.length == 0"
                            >
                              <v-list-item-title>
                                <v-icon color="success">download</v-icon>Reporte de ajustes
                                resumido</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              @click="detail_report()"
                              :disabled="adjustments_filtered.length == 0"
                            >
                              <v-list-item-title>
                                <v-icon color="success">download</v-icon>Reporte de ajustes
                                detallado</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-col cols="2" class="py-0">
                          <v-autocomplete
                            v-model="reason_to_filter"
                            dense
                            hide-details
                            item-text="description"
                            item-value="id"
                            :items="reasons_to_filter"
                            outlined 
                            label="Razon"
                            return-object
                          ></v-autocomplete>
                        </v-col>
                        <v-divider class="mx-3" inset vertical></v-divider>
                             <v-menu bottom origin="center center" transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-if="$store.state.auth.globalFeatures.includes('INV-042') || $store.state.auth.globalFeatures.includes('INV-043')"
                                color="success"
                                dark     :disabled="loading_adjustments"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                              >Nuevo
                                <v-icon class="ml-2">add</v-icon>
                              </v-btn>
                            </template>

                            <v-list>
                              <v-list-item @click="newAdjustment(1)"  v-if="$store.state.auth.globalFeatures.includes('INV-042')">
                                <v-list-item-icon>
                                  <v-icon color="success">add</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Nuevo ajuste</v-list-item-title>
                              </v-list-item>                              
                              <v-list-item @click="newAdjustment(2)" v-if="$store.state.auth.globalFeatures.includes('INV-043')">
                                <v-list-item-icon>
                                  <v-icon color="success">add</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Nueva entrada de ofertas</v-list-item-title>
                              </v-list-item>                              
                            </v-list>
                          </v-menu>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.id`]="{ item }">
                      <v-hover v-slot="{ hover }">
                        <span
                          @click="viewAdjustemnts(item.id)"
                          class="primary--text font-weight-normal text-truncate font-weight-semibold"
                          :style="{
                            color: hover ? 'red' : 'black',
                            cursor: hover ? 'pointer' : '',
                            'text-decoration': hover ? 'underline' : '',
                          }"
                        >
                          {{ filLeft(item.id.toString(), 12, "0") }}</span
                        >
                      </v-hover>
                    </template>
                    <template v-slot:[`item.show`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            @click="viewDetail(item)"
                            large
                          >
                            swap_vertical_circle
                          </v-icon>
                        </template>
                        <span>Ajustar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  <v-card>
                    <v-row justify="end" align="center">
                      <v-col cols="12" md="1">
                        <span
                          class="font-weight-bold"
                          style="color: #607d8b; font-size: 15px"
                        >
                          TOTAL
                        </span>
                      </v-col>
                      <v-col md="2" align="center">
                        <th
                          style="font-size: 20px"
                          class="font-weight-bold text-right success--text"
                        >
                          {{
                            currencyFormat(
                              adjustments_filtered.reduce((sum, item) => {
                                return sum + parseFloat(item.accounting_amount || 0);
                              }, 0)
                            )
                          }}
                          USD
                        </th>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-card>
        </v-expand-transition>
          <v-card outlined  v-show="step == 2">
            <v-card-title>
                <v-btn
                color="error"
                @click="(step = 1), ($route.params.id = undefined)"
                dense outlined small
              ><v-icon small>arrow_back</v-icon>
              Volver
              </v-btn>
              <v-spacer></v-spacer>
              <span :style="`color:#757575;font-size:20px`">{{ dialogTitle }}</span>
              <v-btn icon @click="print()">
                <v-icon>print</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
      
            </v-card-title>
            <v-card-text>
              <v-divider class="mx-2" inset></v-divider>
              <v-container fluid>
                <v-card class="pt-3" flat height="70vh">
                  <v-container fluid>
                    <v-row justify="center" v-if="isNewAdjustment" class="mb-3">
                      <v-col cols="12" md="8">
                        <v-card-text class="pa-3">
                          <v-row justify="center">
                            <v-col cols="8" class="py-0">
                              <v-autocomplete
                                v-model="reason"
                                dense
                                hide-details
                                item-text="description"
                                item-value="id"
                                :items="
                                  adjustmentReasons.filter((element) => element.id > 0)
                                "
                                outlined :disabled="adjustment_type==2"
                                label="Razon"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row justify="center">
                            <v-col cols="8">
                              <v-textarea
                                v-model="note"
                                outlined
                                label="Comentario *"
                                rows="2"
                                :rules="[(v) => !!v || 'El comentario es obligatorio']"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card outlined @click="dialogItems = true" fill-height>
                          <v-card-text class="pa-3">
                            <span
                              :style="`font-size:20px`"
                              class="d-flex justify-center align-center"
                              align="center"
                              justify="center"
                            >
                              Agregar articulo<v-icon color="success">add</v-icon>
                            </span>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row justify="center" class="mb-3">
                      <v-col cols="12" md="6" class="pa-0">
                        <span
                          :style="`font-size:20px`"
                          class="d-flex justify-center align-center"
                          align="center"
                          justify="center"
                        >
                          {{ adjustmentDetails.length }} articulos ajustados por
                          {{ responsable }}</span
                        >
                      </v-col>
                    </v-row>
                    <v-divider
                      class="mb-3"
                      v-if="adjustmentDetails.length > 0"
                    ></v-divider>
                    <v-row
                      justify="center"
                      align="center"
                      v-for="item in adjustmentDetails"
                      :key="item.item_id"
                      class="ma-0"
                    >
                      <v-col
                        md="2"
                        v-if="all_warehouses.length > 0 && isNewAdjustment"
                      >
                        <v-autocomplete
                          label="Ubicacion"
                          :items="all_warehouses"
                          v-model="item.warehouse_id"
                          hide-details
                          item-text="name"
                          item-value="id"
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                      <v-col  md="3">
                        <v-text-field
                          v-model="item.name"
                          label="Articulo"
                          dense hide-details
                          outlined
                          readonly
                        ></v-text-field>
                      </v-col>
                        <v-col md="2">
                            <v-text-field
                              v-model="item.old_quantity"
                              label="Cantidad actual"
                              dense  disabled
                              outlined  
                              readonly
                              type="number" hide-details
                            >
                            </v-text-field>
                          </v-col>
                        <v-col md="2">
                            <v-text-field
                              v-model="item.new_quantity"
                              :label="'Cantidad '+(parseFloat(item.new_quantity)>=0?'a agregar':'a remover')"
                              dense :min="adjustment_type==2?0:null"
                              outlined @change="validate_quantity(item)"
                              :readonly="!isNewAdjustment"
                              type="number" hide-details
                            >
                            <template v-slot:prepend-inner>
                                <v-icon :color="parseFloat(item.new_quantity) >= 0 ? 'green' : 'red'">
                                  {{ parseFloat(item.new_quantity) >= 0 ? 'mdi-plus' : 'mdi-minus' }}
                                </v-icon>
                              </template>
                            </v-text-field>
                          </v-col>
                           <v-col md="2">
                            <v-text-field
                              :value="parseFloat(item.old_quantity)+parseFloat(item.new_quantity)"
                              label="Cantidad resultante"
                              dense disabled
                              outlined 
                              readonly
                              type="number" hide-details
                            >
                            </v-text-field>
                          </v-col>
                           <v-col cols="12" md="1" class="mb-4" v-if="isNewAdjustment">
                            <v-icon color="error" @click="removeItem(item)">close</v-icon>
                          </v-col>
                      <!-- <v-col md="4">
                        <v-row>
                          <v-col cols="12" md="4"  v-if="adjustment_type==1">
                            <v-text-field
                              v-model="item.old_quantity"
                              label="Cantidad anterior"
                              dense
                              outlined
                              readonly
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="item.new_quantity"
                              :label="adjustment_type==1?'Nueva cantidad':'Cantidad'"
                              dense :min="adjustment_type==2?0:null"
                              outlined @change="validate_quantity(item)"
                              :readonly="!isNewAdjustment"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="3" v-if="adjustment_type==1">
                            <v-text-field
                              :value="itemDetailDifferent(item)"
                              label="Diferencia"
                              dense
                              outlined
                              readonly
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="1" class="mt-2" v-if="isNewAdjustment">
                            <v-icon color="error" @click="removeItem(item)">close</v-icon>
                          </v-col>
                        </v-row>
                      </v-col> -->
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" align="right">
                        <v-btn
                          text
                          color="success"
                          @click="saveAdjustment"
                          v-if="isNewAdjustment && adjustmentDetails.length > 0"
                          :loading="loading"
                          >Guardar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>
            </v-card-text>
          </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-if="$store.state.app.filters.location != null"
      width="auto"
      v-model="dialogItems"
    >
      <articles_catalogue
        v-if="refresArticles"
        @selected-item="addItem"
        :removeItemSelected="false"
        :data="{
          location: $store.state.app.filters.location.value,
          business: $store.state.app.filters.business,
          warehouse: filters.warehouse.id,
          catalogue: filters.location.catalogue_id,
          show_warehouse: false,
        }"
        @close-item="dialogItems = false"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import ExcelJS from "exceljs";
import articles_catalogue from "@/components/Inventory/CatalogeForAdjustment.vue";
import HeaderFilters from "@/components/Inventory/HeaderFilters.vue";
export default {
  data: () => ({
    showBar: false,
    showHeader: false,
    filters: {
      location: { catalogue_id: "", value: "" },
      business: "",
      warehouse: { id: "", name: "" },
      dateStart: null,
      dateEnd: null,
    },
    note: "",
    reason: null,
    reason_to_filter: null,
    step: 1,
    refresArticles: false,
    loading_adjustments: false,
    loading: false,
    newQuantity: 0,
    categorys: [],
    all_warehouses: [],
    dialogItems: false,
    adjustmentDetails: [
      {
        item_id: null,
        name: null,
        old_quantity: null,
        new_quantity: null,
        quantity_difference: null,
      },
    ],

    isNewAdjustment: false,
    adjustments: [],
    adjustmentReasons: [],
    search: "",
    headerArticle: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Nota", value: "note" },
      { text: "Location", value: "location" },
      { text: "Fecha", value: "effective_date_formated" },
      { text: "Razon", value: "reason" },
      { text: "Valor", value: "accounting_amount_formated", align: "end" },
      { text: "Responsable", value: "use_fullname" },
      { text: "", value: "show", sortable: false },
    ],
    adjustment_type: 1,
    responsable: null,
    showAll: true,
    articleSelected: { item_name: "", available: 0 },
    rangeSelected: "3",
    dateHeader: "2022-01-01",
    defaultFilters: [],
  }),
  components: {
    articles_catalogue,
    HeaderFilters,
  },
  created() {},
  mounted() {
    if (this.$route.params.id == undefined) {
      this.showHeader = true;
    }
    this.get_reasons();
    this.reason_to_filter = this.reasons_to_filter[0];
    //  this.getAdjustments();
    this.$nextTick(() => {
      if (this.$store.state.app.filters && this.$store.state.app.filters.warehouse) {
        this.filters.warehouse = this.$store.state.app.filters.warehouse;
      }
    });
  },
  computed: {
    dialogTitle() {
      if (this.filters.warehouse == undefined || this.filters.warehouse.id == 0) {
        return "Ajuste";
      }
      if (this.isNewAdjustment == true) {
        return "Ajustar el inventario del " + this.filters.warehouse.name;
      }
      return `Ajuste del ${this.filters.warehouse.name} (${this.dateHeader})`;
    },
    reasons_to_filter() {
      const reasons = Object.assign(this.adjustmentReasons, []);
      reasons.unshift({ description: "TODAS", id: 0 });
      return reasons;
    },
    adjustments_filtered() {
      if (this.reason_to_filter?.id == 0) {
        return this.adjustments;
      }
      return this.adjustments.filter(
        (element) => element.adjustment_reason_id == this.reason_to_filter.id
      );
    },
    reportFileName() {
      let name = "";

      if (this.filters.warehouse && this.filters.warehouse.id !== 0) {
        name = this.filters.warehouse.name; // Usa el nombre del warehouse si está seleccionado
      } else if (this.filters.location && this.filters.location.value !== 0) {
        name = this.filters.location.text; // Usa el nombre de la ubicación si está seleccionada
      } else {
        name = this.filters.business_unit.name; // Usa la unidad de negocio si no hay warehouse ni location
      }

      return `${name} desde ${this.filters.dateStart} hasta ${this.filters.dateEnd}`;
    },
  },
  watch: {},
  methods: {
    viewAdjustemnts(id) {
      let route = this.$router.resolve({
        name: "ViewAdjustment",
        params: { id: id },
      });
      window.open(route.href);
    },
    async get_reasons() {
      const request = await this.api_Get("inventory/adjustmentReasons");
      this.adjustmentReasons = await request.json();
    },
    async getAdjustments(filters) {
      this.all_warehouses = [];
      //si recibe parametros de la ventana de stock ejecuta esa consulta
      if (this.$route.params.id != undefined) {
        this.filters = Object.assign({}, this.$route.params.filtersDefault);
        this.defaultFilters = [];
        this.defaultFilters.push(Object.assign({}, this.$route.params.filtersDefault));
        this.viewDetail({
          id: this.$route.params.id,
          use_fullname: this.$route.params.user,
          effective_date: this.$route.params.effective_date,
        });

        if (this.filters.warehouse == undefined || this.filters.warehouse.id == null) {
          return;
        }
      } else {
        this.filters = filters;
        if (this.filters.warehouse == undefined || this.filters.warehouse.id == null) {
          this.$toast.warning("Escoja un almacen!");
          return;
        }
      }
      this.refresArticles = false;
      this.adjustments = [];
      if (this.filters.location.value == null) {
        return;
      }
      this.loading_adjustments = true;
      try {
        const request = await this.api_Post("inventory/adjustmentsHistory", {
          business_unit_id: this.filters.business,
          location_id: this.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
          dateStart: this.filters.dateStart,
          dateEnd: this.filters.dateEnd,
        });
        const data = await request.json();

        if (request.status == 200) {
          this.adjustments = data;
        } else {
          this.$toast.error(data.error);
        }
        for (let key in this.adjustments) {
          this.adjustments[key].effective_date_formated = moment(
            this.adjustments[key].effective_date
          ).format("DD/MM/YYYY HH:mm");
          this.adjustments[key].accounting_amount_formated = `USD ${this.currencyFormat(
            this.adjustments[key].accounting_amount
          )}`;
        }
        this.refresArticles = true;
        this.showHeader = true;

        if (filters.warehouse.isParent) {
          const response = await this.api_Post("inventory/warehouse/tree", {
            filters: `	WHERE W.PARENT_WAREHOUSE_ID=${filters.warehouse.id} `,
          });

          if (response.status === 200) {
            const result = await response.json();
            this.all_warehouses = result;
            this.all_warehouses.unshift({
              id: filters.warehouse.id,
              name: filters.warehouse.name,
            });
          }
        }
        this.loading_adjustments = false;
      } catch (error) {
        console.error(error.message);
        this.loading_adjustments = false;
      }
    },
    async viewDetail(item) {
      this.dateHeader = moment(item.effective_date).format("DD/MM/YYYY HH:mm");
      this.isNewAdjustment = false;
      const request = await this.api_Get("inventory/adjustmentDetails/" + item.id);
      const data = await request.json();

      if (request.status == 200) {
        this.adjustmentDetails = data;
        this.responsable = item.use_fullname;
      } else {
        this.$toast.error(data.error);
      }
      this.step = 2;
    },
    newAdjustment(type) {
      // Intentamos usar el almacén del store si está disponible
      if (this.filters.warehouse == undefined || this.filters.warehouse.id == "") {
        if (this.$store.state.app.filters && this.$store.state.app.filters.warehouse) {
          this.filters.warehouse = this.$store.state.app.filters.warehouse;
        } else {
          // Si aún no hay almacén seleccionado, mostramos el mensaje
          this.$toast.warning("Escoja un almacen!");
          return;
        }
      }
      this.adjustment_type=type;
      if(type==2){
        this.reason=7;
      }else{
        this.reason=null;
      }
      this.responsable = this.$store.state.auth.user.user?.fullname;
      this.adjustmentDetails = [];
      this.isNewAdjustment = true;
      this.step = 2;
    },
    addItem(item) {
      let existArticle = this.adjustmentDetails.find(
        (element) => element.item_id == item.item_id
      );

      if (existArticle != undefined) {
        this.$toast.warning(
          "Este articulo ya se encuentra en la lista, puede modificar su nueva cantidad!"
        );
      } else {
        this.adjustmentDetails.unshift({
          item_id: item.item_id,
          name: item.item_name,
          old_quantity: item.quantity,
          new_quantity: 0,
          warehouse_id: this.all_warehouses.length > 0 ? this.all_warehouses[0].id : null,
          quantity_difference: 0,
        });
      }
      this.dialogItems = false;
    },
    async saveAdjustment() {
      try {
        if (this.adjustmentDetails.length === 0) {
          this.$toast.warning("Agregue al menos un articulo!");
          return;
        }

        if (!this.note || this.note.trim() === "") {
          this.$toast.warning("El comentario es obligatorio");
          return;
        }
          // console.log(this.adjustmentDetails)
          // this.adjustmentDetails.forEach(item=>{
          //     item.new_quantity =parseFloat(item.new_quantity) - parseFloat(item.old_quantity)
          // })
          
 
        this.loading = true;

        // Check if there are items assigned to multiple warehouses
        if (this.all_warehouses.length > 0) {
          // Group adjustment details by warehouse_id
          const adjustmentsByWarehouse = this.adjustmentDetails.reduce((acc, item) => {
            const warehouseId = item.warehouse_id; // Assuming each item in adjustmentDetails has a warehouse_id
            if (!acc[warehouseId]) {
              acc[warehouseId] = [];
            }
            acc[warehouseId].push(item);
            return acc;
          }, {});
          // Iterate over each warehouse group and send a separate request
          for (const warehouseId in adjustmentsByWarehouse) {
            const itemsForWarehouse = adjustmentsByWarehouse[warehouseId];
            const requestBody = {
              created_by: this.$store.state.auth.user.user.user_id,
              warehouse_id: warehouseId, // Use the specific warehouse ID for this group
              business_unit_id: this.filters.business,
              location_id: this.filters.location.value,
              adjustment: itemsForWarehouse, // Only send items for the current warehouse
              reason_id: this.reason,
              note: this.note,
            };

            const request = await this.api_Post("inventory/do_adjustment", requestBody);
            const data = await request.json();

            if (request.status !== 200) {
              // If any request fails, toast an error and potentially stop the process
              this.$toast.error(
                `Error al registrar ajuste para almacén ${warehouseId}: ${data.error}`
              );
              // You might want to break here or continue with other warehouses
              this.loading;
              return; // Exit if one fails, or remove this to continue processing others
            }
          }

          this.$toast.success(
            "Ajustes registrados correctamente para todos los almacenes!"
          );
        } else {
          // Original logic for a single warehouse or when all_warehouse is not used
          const request = await this.api_Post("inventory/do_adjustment", {
            created_by: this.$store.state.auth.user.user.user_id,
            warehouse_id: this.filters.warehouse.id,
            business_unit_id: this.filters.business,
            location_id: this.filters.location.value,
            adjustment: this.adjustmentDetails,
            reason_id: this.reason,
            note: this.note,
          });
          const data = await request.json();
          if (request.status === 200) {
            this.$toast.success("Registrado correctamente!");
            this.getAdjustments(this.filters);
            this.note = "";
            this.step = 1;
          } else {
            this.$toast.error(data.error);
          }
        }
      } catch (error) {
        console.error("Error saving adjustment:", error);
        this.$toast.error("Ocurrió un error inesperado al guardar el ajuste.");
      }
      this.loading = false;
    },
    // async saveAdjustment() {
    //   try {
    //     if (this.adjustmentDetails.length == 0) {
    //       this.$toast.warning("Agregue al menos un articulo!");
    //       return;
    //     }

    //     if (!this.note || this.note.trim() === '') {
    //       this.$toast.warning("El comentario es obligatorio");
    //       return;
    //     }
    //     const request = await this.api_Post("inventory/do_adjustment", {
    //       created_by: this.$store.state.auth.user.user.user_id,
    //       warehouse_id: this.filters.warehouse.id,
    //       business_unit_id: this.filters.business,
    //       location_id: this.filters.location.value,
    //       adjustment: this.adjustmentDetails,
    //       reason_id: this.reason,
    //       note: this.note
    //     });
    //     const data = await request.json();
    //     if (request.status == 200) {
    //       this.$toast.success("Registrado correctamente!");
    //       this.getAdjustments(this.filters);
    //       this.note = ""
    //       this.step = 1;
    //     } else {
    //       this.$toast.error(data.error);
    //     }
    //   } catch (error) { }
    // },
    itemDetailDifferent(item) {
      return parseFloat(item.new_quantity) - parseFloat(item.old_quantity);
    },
    removeItem(item) {
      let indice = this.adjustmentDetails.indexOf(item);
      this.adjustmentDetails.splice(indice, 1);
    },
    onClickOutside() {
      this.showBar = false;
    },
    async resume_report() {
      // Crear un nuevo libro de Excel y una hoja
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Ajustes");

      // Definir encabezados
      worksheet.columns = [
        { header: "ID", key: "id", width: 10 },
        { header: "Ubicación", key: "location", width: 20 },
        { header: "Almacén", key: "warehouse", width: 20 },
        { header: "Fecha Efectiva", key: "effective_date", width: 20 },
        { header: "Razón", key: "reason", width: 30 },
        { header: "Monto", key: "accounting_amount", width: 15 },
        { header: "Nota", key: "note", width: 50 },
        { header: "Usuario", key: "use_fullname", width: 20 },
      ];

      // Agregar datos a la hoja
      this.adjustments_filtered.forEach((item) => {
        worksheet.addRow({
          id: item.id,
          location: item.location,
          warehouse: item.warehouse,
          effective_date: new Date(item.effective_date).toLocaleString(), // Formatear fecha
          reason: item.reason,
          accounting_amount: parseFloat(item.accounting_amount).toFixed(2),
          note: item.note,
          use_fullname: item.use_fullname,
        });
      });

      // Estilizar encabezados (opcional)
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
      });

      // Generar el archivo Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Reporte resumido de ajustes ${this.reportFileName}.xlsx`;
      link.click();
    },
    async detail_report() {
      try {
        const request = await this.api_Post("inventory/adjustment_detail_report", {
          business_unit_id: this.filters.business,
          location_id: this.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
          dateStart: this.filters.dateStart,
          dateEnd: this.filters.dateEnd,
          reason_id: this.reason_to_filter.id,
        });
        const data = await request.json();
        if (request.status != 200) {
          this.$toast.error(data.error);
        }
        // Crear un nuevo libro de Excel y una hoja
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Ajustes Inventario");

        // Definir encabezados
        worksheet.columns = [
          { header: "Unidad de Negocio", key: "business_unit_description", width: 20 },
          { header: "Ubicación", key: "location_description", width: 20 },
          { header: "Almacén", key: "warehouse_name", width: 20 },
          { header: "Razon", key: "ajustment_description", width: 25 },
          { header: "Fecha", key: "effective_date", width: 20 },
          { header: "ID del Ítem", key: "item_id", width: 10 },
          { header: "Ítem", key: "name", width: 25 },
          { header: "Nota", key: "note", width: 50 },
          // { header: "Cantidad Anterior", key: "old_quantity", width: 15 },
          // { header: "Cantidad Nueva", key: "new_quantity", width: 15 },
          { header: "Cantidad ajustada", key: "quantity_difference", width: 15 },
          { header: "Monto", key: "accounting_amount", width: 15 },
        ];

        // Agregar datos a la hoja
        data.forEach((item) => {
          worksheet.addRow({
            business_unit_description: item.business_unit_description,
            location_description: item.location_description,
            warehouse_name: item.warehouse_name,
            ajustment_description: item.ajustment_description,
            effective_date: new Date(item.effective_date).toLocaleString(), // Formatear fecha
            item_id: item.item_id,
            name: item.name,
            note: item.note,
            // old_quantity: item.old_quantity,
            // new_quantity: item.new_quantity,
            quantity_difference: item.quantity_difference,
            accounting_amount: parseFloat(item.accounting_amount).toFixed(2),
          });
        });

        // Estilizar encabezados
        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
        });

        // Generar el archivo Excel
        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Reporte detallado de ajustes ${this.reportFileName}.xlsx`;
        link.click();
      } catch (error) {
        console.error(error.message);
      }
    },
    async print() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Items");

      // Agregar columnas
      worksheet.columns = [
        { header: "Item ID", key: "item_id", width: 10 },
        { header: "Nombre", key: "name", width: 30 },
        { header: "Cantidad Antigua", key: "old_quantity", width: 20 },
        { header: "Cantidad Nueva", key: "new_quantity", width: 20 },
        { header: "Diferencia", key: "quantity_difference", width: 15 },
      ];

      // Agregar filas
      this.adjustmentDetails.forEach((item) => {
        worksheet.addRow(item);
      });

      // Generar el archivo como blob para navegador
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Ajuste de inventario ${moment().format(
        "DD-MM-YYYY hh-mm-ss"
      )}.xlsx`;
      link.click();
    },
    validate_quantity(item) {
      if (this.adjustment_type == 2 && parseFloat(item.new_quantity) < 0) {
        item.new_quantity = 0;     
        this.$toast.info("Cantidad no valida!");
      } 
    },
  },
};
</script>
